module.exports = __webpack_public_path__ + "static/adda_wink_carouse_1-c54698a53651cf864ad27bef4cd1a2b2.jpg";